import classNames from 'classnames';
import { privacyPolicyLink, termsAndConditionsLink } from '../../config';
import Txt from '../Txt';
import styles from './AgreePolicyBlock.module.scss';

/**
 * AgreePolicyBlock
 *
 * @return {JSX.Element}
 */
const AgreePolicyBlock = ({ className, preText = 'By continuing' }) => {
  return (
    <div
      className={classNames(
        styles.AgreePolicyBlock,
        className,
        AgreePolicyBlock.displayName
      )}
    >
      <Txt regular xx>
        {preText} you are agreeing to our{' '}
        <a href={termsAndConditionsLink} target="_blank" rel="noreferrer">
          Terms and conditions
        </a>{' '}
        and{' '}
        <a href={privacyPolicyLink} target="_blank" rel="noreferrer">
          Privacy policy.
        </a>
      </Txt>
    </div>
  );
};

AgreePolicyBlock.displayName = 'AgreePolicyBlock';

export default AgreePolicyBlock;
